import * as React from "react";

const { Component } = React;

import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from "reactstrap";
import { orderBy } from "lodash";
import Avatar from "react-avatar";
import * as OrganizationStore from "../organizations/OrganizationStore";
import * as AccountStore from "../account/AccountStore";
import { Context, SetOrganization } from "../general/ApplicationContext";
import { Organization } from "../users/UserStore";

import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const OrganizationContextSwitcher = () => {
    let [filter, setFilter] = React.useState("");
    let [organizationDropdownOpen, setOrganizationDropdownOpen] = React.useState(false);
    let [organizations, setOrganizations] = React.useState([] as Organization[]);
    let [organizationsFiltered, setOrganizationsFiltered] = React.useState([] as Organization[]);
    let [currentOrganization, setCurrentOrganization] = React.useState({} as Organization);
    let [currentUser, setCurrentUser] = React.useState({} as AccountStore.Account);

    React.useEffect(() => {
        OrganizationStore.getOrganizations((response) => {
            if (response && response.length > 0) {
                setOrganizations(response);
                AccountStore.GetCurrentLoggedInUser().then((user) => {
                    setCurrentUser(user);
                    var context = Context();
                    if (context.currentOrganization.id) {
                        selectOrganization(context.currentOrganization)();
                    } else {
                        if (user.organization) {
                            selectOrganization(response.filter((o) => o.id == user.organization)[0])();
                        } else {
                            selectOrganization(response[0])();
                        }
                    }
                });
            }
        });
    }, []);

    React.useEffect(() => {
        filterOrganizations(filter);
    }, [organizations, filter]);

    const toggleOrganizationDropdown = () => {
        setOrganizationDropdownOpen(!organizationDropdownOpen);
    };

    const organizationSearchOnChange = (e) => {
        let value = e.target.value;
        setFilter(value);
    };

    const filterOrganizations = (filter?) => {
        filter = filter || "";
        try {
            let filterRegex = new RegExp(filter, "i");
            let organizationsFiltered = organizations;
            if (filter) {
                organizationsFiltered = organizations.filter((org) => {
                    let match = false;

                    match = match || filterRegex.test(org.name);

                    return match;
                });
            }
            setOrganizationsFiltered(orderBy(organizationsFiltered, ["name", "asc"]));
        } catch (e) {}
    };

    const selectOrganization = (organization) => () => {
        setCurrentOrganization(organization);
        SetOrganization(organization);
        setFilter("");
    };

    return (
        <div className=" d-flex" style={{ padding: "0.5rem", paddingLeft: "5rem", backgroundColor: "var(--bs-accent)" }}>
            <Link to="/profile" className="pr-3">
                <Avatar round={true} size={"33px"} name={currentUser.fullName} src={currentUser.photo} />
                {/* {!AccountStore.ProfileRequirementsMet() && (
                    <span style={{ paddingLeft: "1rem" }} title="Complete your profile">
                        <FontAwesomeIcon size="lg" color="orange" icon={["fad", "warning"]}></FontAwesomeIcon>
                    </span>
                )} */}
            </Link>
            <div style={{}}>
                {organizations.length == 0 && <span className="btn text-white">No Organization</span>}
                {organizations.length == 1 && <span className="btn text-white">{currentOrganization.name || "No Organization"}</span>}
                {organizations.length > 1 && (
                    <Dropdown isOpen={organizationDropdownOpen} toggle={toggleOrganizationDropdown}>
                        <DropdownToggle caret style={{ color: "black", backgroundColor: "white", borderColor: "white" }}>
                            {currentOrganization.name || "Select Organization"}
                        </DropdownToggle>
                        <DropdownMenu>
                            {organizations.length > 5 && (
                                <div className="p-2">
                                    <Input name="searchOrganization" placeholder="Search" onChange={organizationSearchOnChange} value={filter}></Input>
                                </div>
                            )}
                            {organizationsFiltered.map((org, i) => (
                                <DropdownItem key={`org${i}`} onClick={selectOrganization(org)}>
                                    {org.name}
                                </DropdownItem>
                            ))}
                        </DropdownMenu>
                    </Dropdown>
                )}
            </div>
        </div>
    );
};

export default OrganizationContextSwitcher;
